import React from "react";

function IconHomeMulti(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 24"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.26 4.123a.9.9 0 0 0-1.186 0l-7.2 6.3a.9.9 0 0 0-.307.677v8.1a.9.9 0 0 0 .9.9h14.4a.9.9 0 0 0 .9-.9v-8.1a.9.9 0 0 0-.308-.677l-7.2-6.3ZM6.366 18.3v-6.792l5.4-4.725V18.3h-5.4Zm7.2 0h5.4v-6.792l-5.4-4.725V18.3Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconHomeMulti;
